<template>
  <Card :name="config.variableFullName">
    <template v-slot:header>
      <h5 class="card-category pull-right">
        {{ getTimeAgo((nowTime - time) / 1000) }}
      </h5>
      <h4 class="card-title">
        {{ config.variableFullName }}
      </h4>
    </template>
    <h3 class="card-title">
      <i
        class="fa"
        :class="[config.icon, getIconColorClass()]"
        aria-hidden="true"
        style="font-size: 30px"
      ></i>
      <div class="form-check form-switch pull-right">
        <input
          @change="showAlertConfirm()"
          v-model="value"
          type="checkbox"
          style="margin-top: 10px"
          class="form-check-input"
        />
      </div>
    </h3>
  </Card>
</template>

<script>
import emitter from "@/eventBus";
export default {
  name: "iotswitch",
  props: ["config"],

  data() {
    return {
      setValue: false,
      value: false,
      topic: "",
      time: Date.now(),
      nowTime: Date.now(),
    };
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          this.value = false;

          emitter.off(this.topic + "/sdata");
          let variable = this.config.variable;
          if (this.$store.state.selectedDevice.ext_mqtt) {
            variable = this.config.variableFullName;
          }
          this.topic =
            this.config.userId +
            "/" +
            this.config.selectedDevice.dId +
            "/" +
            variable;
          emitter.on(this.topic + "/sdata", this.procesReceivedData);
        }, 300);
      },
    },
  },

  mounted() {
    this.getNow();
  },
  beforeDestroy() {
    emitter.off(this.topic);
  },
  methods: {
    showAlertConfirm()  {
      const prev_status = !this.value
      this.$swal({
        title: `Confirmar Cambio de estado de ${this.config.variableFullName}`,
        text: `Esta seguro de [${this.value ? 'Activar' : 'Desactivar'}] ${this.config.variableFullName} `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendValue()
          } else {
            this.value = prev_status
          } 
        })

    },
    getNow() {
      this.nowTime = Date.now();
      setTimeout(() => {
        this.getNow();
      }, 1000);
    },
    getTimeAgo(seconds) {
      if (seconds < 0) {
        seconds = 0;
      }

      if (seconds < 59) {
        return seconds.toFixed() + " secs";
      }

      if (seconds > 59 && seconds <= 3600) {
        seconds = seconds / 60;
        return seconds.toFixed() + " min";
      }

      if (seconds > 3600 && seconds <= 86400) {
        seconds = seconds / 3600;
        return seconds.toFixed() + " hour";
      }

      if (seconds > 86400) {
        seconds = seconds / 86400;
        return seconds.toFixed() + " day";
      }
    },
    getIconColorClass() {
      //para apagar el icono
      if (!this.value) {
        return "text-dark";
      }

      if (this.config.class == "success") {
        return "text-success";
      }
      if (this.config.class == "primary") {
        return "text-primary";
      }
      if (this.config.class == "warning") {
        return "text-warning";
      }
      if (this.config.class == "danger") {
        return "text-danger";
      }
    },

    sendValue() {
      // this.value = !this.value
      const toSend = {
        topic: this.topic + "/actdata",
        msg: {
          value: this.value,
        },
      };
      emitter.emit("mqtt-sender", toSend);
    },

    procesReceivedData(data) {
      if (data == null) return;
      try {
        this.time = Date.now()
        this.value = !!data.value;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style></style>
